import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "" } },
    [
      _c(
        VRow,
        { attrs: { justify: "center" } },
        [
          _c(
            VCol,
            { attrs: { cols: "12", md: "10" } },
            [
              _c(
                VCard,
                { staticClass: "pa-5" },
                [
                  _c(
                    VCardTitle,
                    [
                      _c("span", { staticClass: "headline" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$vuetify.lang.t(
                                "$vuetify.processConversionReport.title"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c(VSpacer),
                      _c(
                        VBtn,
                        {
                          attrs: { icon: "" },
                          on: { click: _vm.toggleParameters },
                        },
                        [
                          _c(VIcon, [
                            _vm._v(
                              _vm._s(
                                _vm.showParameters
                                  ? "mdi-chevron-up"
                                  : "mdi-chevron-down"
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(VExpandTransition, [
                    _vm.showParameters
                      ? _c(
                          "div",
                          [
                            _c("conversion-report-parameters", {
                              attrs: {
                                processTypes: _vm.processTypes,
                                linkedProcessTypes: _vm.linkedProcessTypes,
                                inputProducts: _vm.inputProducts,
                                outputProducts: _vm.outputProducts,
                                isInputProductsLoading:
                                  _vm.isInputProductsLoading,
                                isOutputProductsLoading:
                                  _vm.isOutputProductsLoading,
                              },
                              on: {
                                parametersSelected:
                                  _vm.handleParametersSelected,
                              },
                            }),
                            _c(VDivider, { staticClass: "my-5" }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    VTabs,
                    {
                      attrs: { "background-color": "transparent", grow: "" },
                      model: {
                        value: _vm.selectedTab,
                        callback: function ($$v) {
                          _vm.selectedTab = $$v
                        },
                        expression: "selectedTab",
                      },
                    },
                    [
                      _c(VTab, { key: "aggregated" }, [
                        _vm._v(" Aggregated Report "),
                      ]),
                      _c(VTab, { key: "raw" }, [_vm._v(" Raw Data ")]),
                    ],
                    1
                  ),
                  _c(VDivider),
                  _c(VCardText, [
                    _vm.selectedTab === 0
                      ? _c("div", [
                          _vm.loadingReport
                            ? _c(
                                "div",
                                [
                                  _c(VProgressLinear, {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary",
                                    },
                                  }),
                                ],
                                1
                              )
                            : !_vm.reportData ||
                              (!_vm.reportData.inputInventories.length &&
                                !_vm.reportData.outputInventories.length)
                            ? _c(
                                "div",
                                [
                                  _c(VAlert, { attrs: { type: "info" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$vuetify.lang.t(
                                            "$vuetify.processConversionReport.noReport"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    VRow,
                                    {
                                      staticClass: "mb-3",
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _c(
                                        VCol,
                                        {
                                          staticClass: "d-flex justify-end",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            VBtn,
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.reportFilter.dialog = true
                                                },
                                              },
                                            },
                                            [
                                              _c(VIcon, [
                                                _vm._v("mdi-filter-variant"),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            VBtn,
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.columnFilter.dialog = true
                                                },
                                              },
                                            },
                                            [
                                              _c(VIcon, [
                                                _vm._v("mdi-table-column"),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            VBtn,
                                            {
                                              attrs: { color: "primary" },
                                              on: {
                                                click:
                                                  _vm.exportAggregatedReport,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " Export Aggregated Report to Excel "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(VDataTable, {
                                    staticClass: "elevation-1",
                                    attrs: {
                                      headers: _vm.finalReportHeaders,
                                      items: _vm.filteredFinalReportItems,
                                      dense: "",
                                      "items-per-page": 10,
                                      "footer-props": {
                                        "items-per-page-options": [10, 15, 20],
                                        "items-per-page-text":
                                          _vm.$vuetify.lang.t(
                                            "$vuetify.dataTable.itemsPerPageText"
                                          ),
                                        "show-current-page": true,
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item",
                                          fn: function ({ item, headers }) {
                                            return [
                                              _c(
                                                "tr",
                                                _vm._l(
                                                  headers,
                                                  function (header) {
                                                    return _c(
                                                      "td",
                                                      { key: header.value },
                                                      [
                                                        header.value ===
                                                        "processCodes"
                                                          ? _c(
                                                              "span",
                                                              [
                                                                _vm._l(
                                                                  item.processCodes,
                                                                  function (
                                                                    proc
                                                                  ) {
                                                                    return _c(
                                                                      "div",
                                                                      {
                                                                        key: proc.id,
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "formatDateTime"
                                                                              )(
                                                                                proc.time
                                                                              )
                                                                            ) +
                                                                            " - "
                                                                        ),
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                target:
                                                                                  "_blank",
                                                                                href: `${_vm.backofficeUrl}/factory/process/${proc.id}`,
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  proc.code
                                                                                    ? proc.code
                                                                                    : "N/A"
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " (ID: " +
                                                                            _vm._s(
                                                                              proc.id
                                                                            ) +
                                                                            ") "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  [
                                                                    item.chain
                                                                      ? _c(
                                                                          VBtn,
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                small:
                                                                                  "",
                                                                                icon: "",
                                                                                color:
                                                                                  "primary",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.openSubgraphDialog(
                                                                                    item.chain
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              VIcon,
                                                                              [
                                                                                _vm._v(
                                                                                  "mdi-graph"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              2
                                                            )
                                                          : header.value ===
                                                            "processStartTime"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatDateTime"
                                                                    )(
                                                                      item[
                                                                        header
                                                                          .value
                                                                      ]
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ])
                                                          : _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatNumber"
                                                                    )(
                                                                      item[
                                                                        header
                                                                          .value
                                                                      ]
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "body.append",
                                          fn: function () {
                                            return [
                                              _vm.isFilterActive
                                                ? _c(
                                                    "tr",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold",
                                                    },
                                                    _vm._l(
                                                      _vm.finalReportHeaders,
                                                      function (header, index) {
                                                        return _c(
                                                          "td",
                                                          { key: index },
                                                          [
                                                            header.value ===
                                                            "processCodes"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Filtered Total"
                                                                  ),
                                                                ])
                                                              : _c("span", [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "formatNumber"
                                                                        )(
                                                                          _vm
                                                                            .displayedTotalRow[
                                                                            header
                                                                              .value
                                                                          ]
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "tr",
                                                {
                                                  staticClass:
                                                    "font-weight-bold",
                                                },
                                                _vm._l(
                                                  _vm.finalReportHeaders,
                                                  function (header, index) {
                                                    return _c(
                                                      "td",
                                                      { key: index },
                                                      [
                                                        header.value ===
                                                        "processCodes"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Grand Total"
                                                              ),
                                                            ])
                                                          : _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatNumber"
                                                                    )(
                                                                      _vm
                                                                        .totalRow[
                                                                        header
                                                                          .value
                                                                      ]
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      3253772277
                                    ),
                                  }),
                                  _c("conversion-analysis", {
                                    staticClass: "mt-5",
                                    attrs: {
                                      "aggregated-data":
                                        _vm.filteredFinalReportItems,
                                      "raw-data": _vm.combinedRawInventories,
                                      "overall-aggregated-data":
                                        _vm.finalReportItems,
                                      "overall-raw-data":
                                        _vm.combinedRawInventories,
                                    },
                                  }),
                                ],
                                1
                              ),
                        ])
                      : _vm.selectedTab === 1
                      ? _c(
                          "div",
                          [
                            _c(
                              VRow,
                              { staticClass: "mb-3" },
                              [
                                _c(
                                  VCol,
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      VBtn,
                                      {
                                        attrs: { color: "primary" },
                                        on: { click: _vm.exportRawData },
                                      },
                                      [_vm._v(" Export Raw Data to Excel ")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(VDataTable, {
                              staticClass: "elevation-1",
                              attrs: {
                                headers: _vm.rawCombinedHeaders,
                                items: _vm.combinedRawInventories,
                                dense: "",
                                "items-per-page": 10,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.reportFilter.dialog,
            callback: function ($$v) {
              _vm.$set(_vm.reportFilter, "dialog", $$v)
            },
            expression: "reportFilter.dialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, [
                _c("span", { staticClass: "headline" }, [
                  _vm._v("Filter Aggregated Report"),
                ]),
              ]),
              _c(
                VCardText,
                [
                  _c(
                    VForm,
                    [
                      _c(VSubheader, [_vm._v("Input Product Thresholds")]),
                      _c(VSelect, {
                        attrs: {
                          items: _vm.flatInputProducts,
                          "item-text": "name",
                          "item-value": "id",
                          label: "Select Input Products",
                          multiple: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.reportFilter.selectedInputProductIds,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.reportFilter,
                              "selectedInputProductIds",
                              $$v
                            )
                          },
                          expression: "reportFilter.selectedInputProductIds",
                        },
                      }),
                      _vm._l(
                        _vm.reportFilter.selectedInputProductIds,
                        function (id) {
                          return _c(
                            "div",
                            { key: id, staticClass: "mt-2" },
                            [
                              _c(VTextField, {
                                attrs: {
                                  label: `Threshold for ${_vm.getInputProductName(
                                    id
                                  )}`,
                                  type: "number",
                                  min: "0",
                                },
                                model: {
                                  value: _vm.reportFilter.inputThresholds[id],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.reportFilter.inputThresholds,
                                      id,
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "reportFilter.inputThresholds[id]",
                                },
                              }),
                            ],
                            1
                          )
                        }
                      ),
                      _c(VSubheader, { staticClass: "mt-4" }, [
                        _vm._v("Output Product Thresholds"),
                      ]),
                      _c(VSelect, {
                        attrs: {
                          items: _vm.flatOutputProducts,
                          "item-text": "name",
                          "item-value": "id",
                          label: "Select Output Products",
                          multiple: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.reportFilter.selectedOutputProductIds,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.reportFilter,
                              "selectedOutputProductIds",
                              $$v
                            )
                          },
                          expression: "reportFilter.selectedOutputProductIds",
                        },
                      }),
                      _vm._l(
                        _vm.reportFilter.selectedOutputProductIds,
                        function (id) {
                          return _c(
                            "div",
                            { key: id, staticClass: "mt-2" },
                            [
                              _c(VTextField, {
                                attrs: {
                                  label: `Threshold for ${_vm.getOutputProductName(
                                    id
                                  )}`,
                                  type: "number",
                                  min: "0",
                                },
                                model: {
                                  value: _vm.reportFilter.outputThresholds[id],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.reportFilter.outputThresholds,
                                      id,
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "reportFilter.outputThresholds[id]",
                                },
                              }),
                            ],
                            1
                          )
                        }
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    { attrs: { text: "" }, on: { click: _vm.resetFilters } },
                    [_vm._v("Reset")]
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.reportFilter.dialog = false
                        },
                      },
                    },
                    [_vm._v("Apply")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.columnFilter.dialog,
            callback: function ($$v) {
              _vm.$set(_vm.columnFilter, "dialog", $$v)
            },
            expression: "columnFilter.dialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, [
                _c("span", { staticClass: "headline" }, [
                  _vm._v("Select Displayed Columns"),
                ]),
              ]),
              _c(
                VCardText,
                [
                  _c(
                    VForm,
                    [
                      _c(VSubheader, [_vm._v("Input Product Columns")]),
                      _c(VSelect, {
                        attrs: {
                          items: _vm.flatInputProducts,
                          "item-text": "name",
                          "item-value": "id",
                          label: "Select Input Columns",
                          multiple: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.columnFilter.selectedInputColumns,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.columnFilter,
                              "selectedInputColumns",
                              $$v
                            )
                          },
                          expression: "columnFilter.selectedInputColumns",
                        },
                      }),
                      _c(VSubheader, { staticClass: "mt-4" }, [
                        _vm._v("Output Product Columns"),
                      ]),
                      _c(VSelect, {
                        attrs: {
                          items: _vm.flatOutputProducts,
                          "item-text": "name",
                          "item-value": "id",
                          label: "Select Output Columns",
                          multiple: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.columnFilter.selectedOutputColumns,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.columnFilter,
                              "selectedOutputColumns",
                              $$v
                            )
                          },
                          expression: "columnFilter.selectedOutputColumns",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: { text: "" },
                      on: { click: _vm.resetColumnSelection },
                    },
                    [_vm._v("Reset")]
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.columnFilter.dialog = false
                        },
                      },
                    },
                    [_vm._v("Apply")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          attrs: { "max-width": "700", scrollable: "" },
          model: {
            value: _vm.subgraphDialog.visible,
            callback: function ($$v) {
              _vm.$set(_vm.subgraphDialog, "visible", $$v)
            },
            expression: "subgraphDialog.visible",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardTitle,
                [
                  _c("span", { staticClass: "headline" }, [
                    _vm._v(
                      " Subgraph Details - Chain " +
                        _vm._s(_vm.subgraphDialog.chainId) +
                        " "
                    ),
                  ]),
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: { icon: "" },
                      on: { click: _vm.closeSubgraphDialog },
                    },
                    [_c(VIcon, [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(VCardText, [
                _vm.subgraphDialog.subgraph
                  ? _c(
                      "div",
                      [
                        _c("p", [_c("strong", [_vm._v("Visited Processes:")])]),
                        _vm._l(
                          _vm.subgraphDialog.subgraph.visitedProcessIds,
                          function (pid) {
                            return _c(
                              "div",
                              { key: pid, staticClass: "ml-4" },
                              [
                                _vm._v(" Process ID: "),
                                _c("strong", [_vm._v(_vm._s(pid))]),
                                _vm._v(" | Code: "),
                                _c("strong", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.processMap[pid] &&
                                          _vm.processMap[pid].processCode
                                          ? _vm.processMap[pid].processCode
                                          : "N/A"
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]
                            )
                          }
                        ),
                        _vm._l(
                          _vm.subgraphDialog.subgraph.edges,
                          function (edge, edgeIndex) {
                            return _c(
                              "div",
                              { key: edgeIndex, staticClass: "my-4" },
                              [
                                _c("div", [
                                  _c("strong", [
                                    _vm._v("Edge #" + _vm._s(edgeIndex + 1)),
                                  ]),
                                ]),
                                _c("div", { staticClass: "ml-4" }, [
                                  _vm._v(" Source: "),
                                  _c("strong", [_vm._v(_vm._s(edge.sourceId))]),
                                  _vm._v(
                                    " (" +
                                      _vm._s(
                                        _vm.processMap[edge.sourceId] &&
                                          _vm.processMap[edge.sourceId]
                                            .processCode
                                          ? _vm.processMap[edge.sourceId]
                                              .processCode
                                          : "N/A"
                                      ) +
                                      ") "
                                  ),
                                ]),
                                _c("div", { staticClass: "ml-4" }, [
                                  _vm._v(" Target: "),
                                  _c("strong", [_vm._v(_vm._s(edge.targetId))]),
                                  _vm._v(
                                    " (" +
                                      _vm._s(
                                        _vm.processMap[edge.targetId] &&
                                          _vm.processMap[edge.targetId]
                                            .processCode
                                          ? _vm.processMap[edge.targetId]
                                              .processCode
                                          : "N/A"
                                      ) +
                                      ") "
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "ml-4 mt-2" },
                                  [
                                    _c("strong", [
                                      _vm._v("Linking Inventories:"),
                                    ]),
                                    _vm._l(
                                      edge.linkingInventoryIds,
                                      function (invId) {
                                        return _c(
                                          "div",
                                          { key: invId, staticClass: "ml-4" },
                                          [
                                            _vm._v(" - Inventory ID: "),
                                            _c("strong", [
                                              _vm._v(_vm._s(invId)),
                                            ]),
                                            _vm._v(", Product: "),
                                            _c("strong", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.inventoryMap[invId] &&
                                                      _vm.inventoryMap[invId]
                                                        .productName
                                                      ? _vm.inventoryMap[invId]
                                                          .productName
                                                      : "N/A"
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            )
                          }
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.closeSubgraphDialog },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }